import { inject } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

/**
 * Converts the Date type to string deeply
 *
 * As JSON.stringify converts the Date to string timestamp.
 * This usually needed to avoid Date type issue
 * when a data is stringified then parsed again
 * using JSON.stringify/JSON.parse methods to save
 * the data some where like localStorage or etc.
 */
type JSONParse<T> = T extends Date
  ? string
  : T extends Array<infer E>
  ? JSONParse<E>
  : T extends object
  ? { [K in keyof T]: JSONParse<T[K]> }
  : T;

export class Persist<T = unknown, Safe extends boolean = true, U = JSONParse<T>> {
  private storage = inject(Storage);

  constructor(private key: string) {}

  async write(value: T) {
    await this.storage.set(this.key, value);
  }

  read(): Promise<(Safe extends true ? U : T) | null>;
  read<R>(project: (value: U | null) => R): Promise<R>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async read(project?: any): Promise<any> {
    const value = await this.storage.get(this.key);
    if (project) return project(value);
    return value;
  }

  async clear() {
    return await this.storage.remove(this.key);
  }
}
